import React from 'react';
import ChannelManagersFiltersBar from './ChannelManagersFiltersBar';
import ChannelManagersList from './ChannelManagersList';
import '../../../../stylesheets/stylesLayout/channel-managers.scss';

const ChannelManagers = () => {
    return (
        <section className='channel-managers__page'>
            <ChannelManagersFiltersBar />
            <ChannelManagersList />
        </section>
    );
};

export default ChannelManagers;
